module.exports = __webpack_public_path__ + "img/66.c648f791.jpg";